const API_GATEWAY = process.env.REACT_APP_URL_API_GATEWAY;
export const API_BASE = `${API_GATEWAY}/elecOf`;
export const API_BASE_FILES = `${API_GATEWAY}/elecOf/files`;
export const API_ECM = `${API_GATEWAY}/ecm`;
export const API_BACK_OFFICE = `${API_GATEWAY}/bpm`;
export const API_AUTHENTICATION = `${API_GATEWAY}/auth`;
export const API_PQRSD = `${API_GATEWAY}/pqrsd`;
export const STORAGE_TOKEN = 'ElectronicOfficeToken';

